import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { MobileChatProviderCore, } from "./MobileChatProvider";
import { useMobileWallet } from "../wallet/MobileWalletProvider";
import { signMessage as wcSignMessage } from "../wallet/mobileWalletConfig";
import { ChatSecurityProvider, useChatSecurity, } from "../../provider/ChatSecurityProvider";
export const MobileChatSecurityProvider = ({ children, }) => {
    const { address, isAuthenticated, isConnected, walletProvider } = useMobileWallet();
    const walletSource = useMemo(() => ({
        address,
        provider: walletProvider,
        isConnected,
        isAuthenticated,
    }), [address, walletProvider, isConnected, isAuthenticated]);
    return (_jsx(ChatSecurityProvider, { walletSource: walletSource, children: children }));
};
/**
 * Dashboard-specific wallet adapter for the shared mobile chat/call engine.
 * The separate /m/ bundle has its own adapter and never imports this module.
 */
export const MobileChatProvider = ({ children, }) => {
    const { address, walletProvider } = useMobileWallet();
    const security = useChatSecurity();
    const normalizedAddress = useMemo(() => address?.toLowerCase() || "", [address]);
    const readySecurityScope = !!normalizedAddress &&
        security.wallet === normalizedAddress &&
        security.status === "ready" &&
        security.keyReady &&
        security.provider === walletProvider &&
        !!walletProvider &&
        !!security.v2KeyBytes &&
        !!security.deviceId &&
        !!security.deviceSessionToken;
    const signChatKeyMessage = useMemo(() => {
        if (!normalizedAddress)
            return null;
        return (message) => wcSignMessage(message, normalizedAddress);
    }, [normalizedAddress]);
    return (_jsx(MobileChatProviderCore, { address: address, signChatKeyMessage: signChatKeyMessage, securityEnabled: true, preloadedV2KeyBytes: readySecurityScope ? security.v2KeyBytes : null, suppliedDeviceId: readySecurityScope ? security.deviceId : null, deviceSessionToken: readySecurityScope ? security.deviceSessionToken : null, onDeviceSessionRejected: readySecurityScope ? security.renewDeviceSession : null, children: children }));
};
